import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import styles from './ContactUs.module.css';

const ContactUs = () => {
  return (
    <div className={styles.contactSection}>
      <Container>
        <h2 className="text-center mb-4">Contact Us</h2>
        <Row>
          {/* <Col md={6}>
            <Card className="p-4 shadow-sm">
              <h4>Get in Touch</h4>
              <Form>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter your name" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control as="textarea" rows={4} placeholder="Enter your message" />
                </Form.Group>

                <Button variant="primary" type="submit">
                  Send Message
                </Button>
              </Form>
            </Card>
          </Col> */}

          <Col md={12}>
            <Card className="p-4 shadow-sm bg-light">
              <h4>Rave Cabs Private Limited</h4>
              <p><strong>Address:</strong> 109, Sachivalya Vihar, Ricco Kanta, Mansarovar, Jaipur, Rajasthan</p>
              <p><strong>Phone:</strong> +91-8239839490</p>
              <p><strong>Email:</strong> ravecabs.care@gmail.com</p>
              <p><strong>Working Hours:</strong> 24/7</p>
              <div className="mt-3">
                <iframe
                  title="Location Map"
                  src="https://maps.google.com/maps?q=jaipur&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="500"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;